import { render, staticRenderFns } from "./cards-summary.vue?vue&type=template&id=95305fc0&scoped=true"
import script from "./cards-summary.vue?vue&type=script&lang=js"
export * from "./cards-summary.vue?vue&type=script&lang=js"
import style0 from "./cards-summary.vue?vue&type=style&index=0&id=95305fc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95305fc0",
  null
  
)

export default component.exports